import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import RecipeLineItemNumber from "../Recipe/RecipeLineItemNumber";

/**
 * Renderer for RecipeLineItem's QtyDefault under FoodBOMLineItem
 */
const QtyDefault = declare(RecipeLineItemNumber, {

	/**
	 * @override
	 * Render RecipeLineItem's "QtyDefault" in FoodBOM
	 */
	toValue(ctx: Context, h: Heading): string {
		const value = this.getAmountInFoodBOM(ctx);
		return this.formatValue(value, this._getFormat(ctx, h));
	},

});

export = QtyDefault;